import React from 'react';
import './Question.scss';
import { divideText } from '../../../../helper/dividerForTextNote';
import PropTypes from 'prop-types';


function Question(props) {
        
        return (
            <div className="Question">
                {divideText(props.content)}
            </div>
        )
}
Question.propTypes = {
    content: PropTypes.string.isRequired
  };
export default Question;
